import React from 'react';
import '../css/bootstrap.min.css';
import ourservices from '../img/services/our-services.jpg';
import crossline2 from '../images/background/cross-line2.png';
import fancylights from '../img/services/retail-fancy-lights.jpg';
import ledlights from '../img/services/led-lights.jpg';
import lithiumbatteries from '../img/services/lithium-batteries.jpg';
import inveterups from '../img/services/inveter-ups.jpg';
import stainlesssteel from '../img/services/stainless-steel-manufacturing.jpg';
import infrastructure from '../img/services/infrastructure.jpg';
import clients1 from '../img/clients/1.png';
import clients5 from '../img/clients/5.png';
import clients6 from '../img/clients/6.png';
import clients9 from '../img/clients/9.png';
import clients12 from '../img/clients/12.png';
import clients14 from '../img/clients/14.png';
import '../css/style.css';
import '../css/bootstrap.min.css';
import '../css/footer.css';
import '../css/loader.min.css';
import '../css/fontawesome/css/font-awesome.min.css';
import '../css/skin/skin-1.css';
import '../css/bootstrap-slider.min.css';
import '../css/bootstrap-select.min.css';
import '../css/flaticon.min.css';
import '../css/home.css';
import '../css/magnific-popup.min.css';
import '../css/owl.carousel.min.css';
import '../css/fontawesome/fonts/fontawesome-webfont.svg';
import '../css/fontawesome/fonts/fontawesome-webfont.eot';
import '../css/fontawesome/fonts/fontawesome-webfont.ttf';
import '../css/fontawesome/fonts/fontawesome-webfont.woff';
import '../css/fontawesome/fonts/fontawesome-webfont.woff2';
import '../css/fontawesome/fonts/FontAwesome.otf';
import '../css/fontawesome/less/animated.less';
import '../css/fontawesome/less/bordered-pulled.less';
import '../css/fontawesome/less/core.less';
import '../css/fontawesome/less/fixed-width.less';
import '../css/fontawesome/less/font-awesome.less';
import '../css/fontawesome/less/icons.less';
import '../css/fontawesome/less/larger.less';
import '../css/fontawesome/less/list.less';
import '../css/fontawesome/less/mixins.less';
import '../css/fontawesome/less/path.less';
import '../css/fontawesome/less/rotated-flipped.less';
import '../css/fontawesome/less/screen-reader.less';
import '../css/fontawesome/less/stacked.less';
import '../css/fontawesome/less/animated.less';
import '../css/skin/skin-2.css';
import '../css/skin/skin-3.css';
import '../css/skin/skin-4.css';
import '../css/skin/skin-5.css';
import '../css/skin/skin-6.css';
import '../css/skin/skin-7.css';
import '../css/skin/skin-8.css';
import '../css/skin/skin-9.css';
import '../css/skin/skin-10.css';
import '../fonts/Flaticon.eot';
import '../fonts/Flaticon.ttf';
import '../fonts/Flaticon.woff';
import '../fonts/Flaticon.woff2';
import '../fonts/glyphicons-halflings-regular.svg';
import '../fonts/glyphicons-halflings-regular.eot';
import '../fonts/glyphicons-halflings-regular.ttf';
import '../fonts/glyphicons-halflings-regular.woff';
import '../fonts/glyphicons-halflings-regular.woff2';

function Ourservices() {
  return (
<div className="page-content">
  {/* INNER PAGE BANNER */}
  <div
    className="sx-bnr-inr overlay-wraper bg-parallax bg-top-center"
    data-stellar-background-ratio="0.5"
    style={{ backgroundImage: `url(${ourservices})` }}
  >
    <div className="overlay-main bg-black opacity-07" />
    <div className="container">
      <div className="sx-bnr-inr-entry">
        <div className="banner-title-outer">
          <div className="banner-title-name">
            <h2 className="m-tb0">Our Manufacturing Units</h2>
            <p>
              Explore our integrated manufacturing units, delivering
              quality LED lighting solutions and innovative products tailored to
              meet diverse consumer needs.
            </p>
          </div>
        </div>
       
      </div>
    </div>
  </div>
  {/* INNER PAGE BANNER END */}
  {/* MANUFACTURING START */}
  <div className="section-full1 mobile-page-padding p-t80 p-b50 bg-white">
    <div className="container">
      <div className="section-head">
        <div className="sx-separator-outer separator-center">
          <div
            className="sx-separator bg-white bg-moving bg-repeat-x"
            style={{ backgroundImage: `url(${crossline2})` }}
          >
            <h3 className="sep-line-one">Manufacturing Units</h3>
          </div>
        </div>
      </div>
      <div className="row">
        {/* FANCY LIGHTS STORE */}
        <div className="col-lg-4 col-md-12 m-b30">
          <a href="our-infrastructure.html" className="sx-text-white"></a>
          <div
            className="bgcall-block1 d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
            style={{ backgroundImage: `url(${fancylights})` }}
          >
            <a href="our-infrastructure.html" className="sx-text-white">
              <div className="overlay-main bg-black opacity-05" />
            </a>
            <div className="bg-content-mid-outer">
              <a href="our-infrastructure.html" className="sx-text-white"></a>
              <div className="bg-content-mid">
                <a href="our-infrastructure.html" className="sx-text-white"></a>
                <div className="sx-icon-box-wraper center   text-white">
                  <a href="our-infrastructure.html" className="sx-text-white">
                    <div className="icon-lg1 m-b151">
                      <span className="icon-cell">
                        <i className="flaticon-chandelier" />
                      </span>
                    </div>
                  </a>
                  <div className="icon-content m-b30">
                    <a
                      href="our-infrastructure.html"
                      className="sx-text-white"
                    ></a>
                    <h4 className="sx-tilte">
                      <a
                        href="our-infrastructure.html"
                        className="sx-text-white"
                      />
                      <a
                        href="our-infrastructure.html"
                        className="sx-text-white"
                      >
                        Fancy Lights Store
                      </a>
                    </h4>
                    <p>
                      Visit FINIKE's showroom for a wide range of innovative
                      products, from LED lighting to advanced technology
                      solutions
                    </p>
                  </div>
                </div>
                <span className="bgcall-block-number1">01</span>
                <div className="bg-overlay" />
              </div>
            </div>
          </div>
        </div>
        {/* LED LIGHTS */}
        <div className="col-lg-4 col-md-12 m-b30">
          {" "}
          <a href="/our-services/led-lights.html" className="sx-text-white"></a>
          <div
            className="bgcall-block1 d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
            style={{ backgroundImage: `url(${ledlights})` }}
          >
            <a href="/our-services/led-lights.html" className="sx-text-white">
              <div className="overlay-main bg-black opacity-05" />
            </a>
            <div className="bg-content-mid-outer">
              <a
                href="/our-services/led-lights.html"
                className="sx-text-white"
              ></a>
              <div className="bg-content-mid">
                <a
                  href="/our-services/led-lights.html"
                  className="sx-text-white"
                ></a>
                <div className="sx-icon-box-wraper center   text-white">
                  <a
                    href="/our-services/led-lights.html"
                    className="sx-text-white"
                  >
                    <div className="icon-lg1 m-b151">
                      <span className="icon-cell">
                        <i className="flaticon-living-room" />
                      </span>
                    </div>
                  </a>
                  <div className="icon-content m-b30">
                    <a
                      href="/our-services/led-lights.html"
                      className="sx-text-white"
                    ></a>
                    <h4 className="sx-tilte">
                      <a
                        href="/our-services/led-lights.html"
                        className="sx-text-white"
                      >
                        {" "}
                      </a>
                      <a
                        href="/our-services/led-lights.html"
                        className="sx-text-white"
                      >
                        LED Light
                      </a>
                    </h4>
                    <p>
                      Discover superior LED lighting solutions for indoor,
                      outdoor, and specialized environments with Imperial LED
                    </p>
                  </div>
                </div>
                <span className="bgcall-block-number1">02</span>
                <div className="bg-overlay" />
              </div>
            </div>
          </div>
        </div>
        {/* LITHIUM BATTERY */}
        <div className="col-lg-4 col-md-12 m-b30">
          <a
            href="/our-services/lithium-battery.html"
            className="sx-text-white"
          ></a>
          <div
            className="bgcall-block1 d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
            style={{ backgroundImage: `url(${lithiumbatteries})` }}
          >
            <a
              href="/our-services/lithium-battery.html"
              className="sx-text-white"
            >
              <div className="overlay-main bg-black opacity-05" />
            </a>
            <div className="bg-content-mid-outer">
              <a
                href="/our-services/lithium-battery.html"
                className="sx-text-white"
              ></a>
              <div className="bg-content-mid">
                <a
                  href="/our-services/lithium-battery.html"
                  className="sx-text-white"
                ></a>
                <div className="sx-icon-box-wraper center   text-white">
                  <a
                    href="/our-services/lithium-battery.html"
                    className="sx-text-white"
                  >
                    <div className="icon-lg1 m-b151">
                      <span className="icon-cell">
                        <i className="flaticon-project" />
                      </span>
                    </div>
                  </a>
                  <div className="icon-content m-b30">
                    <a
                      href="/our-services/lithium-battery.html"
                      className="sx-text-white"
                    ></a>
                    <h4 className="sx-tilte">
                      <a
                        href="/our-services/lithium-battery.html"
                        className="sx-text-white"
                      />
                      <a
                        href="/our-services/lithium-battery.html"
                        className="sx-text-white"
                      >
                        Lithium Battery
                      </a>
                    </h4>
                    <p>
                      Finike Lithium pioneers eco-friendly lithium batteries,
                      delivering reliable energy solutions for a sustainable
                      future.
                    </p>
                  </div>
                </div>
                <span className="bgcall-block-number1">03</span>
                <div className="bg-overlay" />
              </div>
            </div>
          </div>
        </div>
        {/* INVERTER UPS */}
        <div className="col-lg-4 col-md-12 m-b30">
          <a
            href="/our-services/inverter-ups.html"
            className="sx-text-white"
          ></a>
          <div
            className="bgcall-block1 d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
            style={{ backgroundImage: `url(${inveterups})` }}
          >
            <a href="/our-services/inverter-ups.html" className="sx-text-white">
              <div className="overlay-main bg-black opacity-05" />
            </a>
            <div className="bg-content-mid-outer">
              <a
                href="/our-services/inverter-ups.html"
                className="sx-text-white"
              ></a>
              <div className="bg-content-mid">
                <a
                  href="/our-services/inverter-ups.html"
                  className="sx-text-white"
                ></a>
                <div className="sx-icon-box-wraper center   text-white">
                  <a
                    href="/our-services/inverter-ups.html"
                    className="sx-text-white"
                  >
                    <div className="icon-lg1 m-b151">
                      <span className="icon-cell">
                        <i className="flaticon-dimensions" />
                      </span>
                    </div>
                  </a>
                  <div className="icon-content m-b30">
                    <a
                      href="/our-services/inverter-ups.html"
                      className="sx-text-white"
                    ></a>
                    <h4 className="sx-tilte">
                      <a
                        href="/our-services/inverter-ups.html"
                        className="sx-text-white"
                      />
                      <a
                        href="/our-services/inverter-ups.html"
                        className="sx-text-white"
                      >
                        Inverter &amp; UPS
                      </a>
                    </h4>
                    <p>
                      We specializes in high-quality inverters and UPS systems
                      for dependable power solutions worldwide
                    </p>
                  </div>
                </div>
                <span className="bgcall-block-number1">04</span>
                <div className="bg-overlay" />
              </div>
            </div>
          </div>
        </div>
        {/* SHEET METAL */}
        <div className="col-lg-4 col-md-12 m-b30">
          <a
            href="/our-services/sheet-metal.html"
            className="sx-text-white"
          ></a>
          <div
            className="bgcall-block1 d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
            style={{ backgroundImage: `url(${stainlesssteel})` }}
          >
            <a href="/our-services/sheet-metal.html" className="sx-text-white">
              <div className="overlay-main bg-black opacity-05" />
            </a>
            <div className="bg-content-mid-outer">
              <a
                href="/our-services/sheet-metal.html"
                className="sx-text-white"
              ></a>
              <div className="bg-content-mid">
                <a
                  href="/our-services/sheet-metal.html"
                  className="sx-text-white"
                ></a>
                <div className="sx-icon-box-wraper center   text-white">
                  <a
                    href="/our-services/sheet-metal.html"
                    className="sx-text-white"
                  >
                    <div className="icon-lg1 m-b151">
                      <span className="icon-cell">
                        <i className="flaticon-lift" />
                      </span>
                    </div>
                  </a>
                  <div className="icon-content m-b30">
                    <a
                      href="/our-services/sheet-metal.html"
                      className="sx-text-white"
                    ></a>
                    <h4 className="sx-tilte">
                      <a
                        href="/our-services/sheet-metal.html"
                        className="sx-text-white"
                      />
                      <a
                        href="/our-services/sheet-metal.html"
                        className="sx-text-white"
                      >
                        Sheet Metal
                      </a>
                    </h4>
                    <p>
                      Discover precision-crafted stainless steel solutions for
                      homes and security with Finike Sheet Metal.
                    </p>
                  </div>
                </div>
                <span className="bgcall-block-number1">05</span>
                <div className="bg-overlay" />
              </div>
            </div>
          </div>
        </div>
        {/* FURNITURE */}
        <div className="col-lg-4 col-md-12 m-b30">
          <a href="/our-infrastructure.html" className="sx-text-white"></a>
          <div
            className="bgcall-block1 d-flex flex-wrap justify-content-center align-content-end bg-cover overlay-wraper"
            style={{ backgroundImage: `url(${infrastructure})` }}
          >
            <a href="/our-infrastructure.html" className="sx-text-white">
              <div className="overlay-main bg-black opacity-05" />
            </a>
            <div className="bg-content-mid-outer">
              <a href="/our-infrastructure.html" className="sx-text-white"></a>
              <div className="bg-content-mid">
                <a
                  href="/our-infrastructure.html"
                  className="sx-text-white"
                ></a>
                <div className="sx-icon-box-wraper center   text-white">
                  <a href="/our-infrastructure.html" className="sx-text-white">
                    <div className="icon-lg1 m-b151">
                      <span className="icon-cell">
                        <i className="flaticon-blueprint" />
                      </span>
                    </div>
                  </a>
                  <div className="icon-content m-b30">
                    <a
                      href="/our-infrastructure.html"
                      className="sx-text-white"
                    ></a>
                    <h4 className="sx-tilte">
                      <a
                        href="/our-infrastructure.html"
                        className="sx-text-white"
                      />
                      <a
                        href="/our-infrastructure.html"
                        className="sx-text-white"
                      >
                        Infrastructure
                      </a>
                    </h4>
                    <p>
                      The state of the art manufacturing facility lithium
                      Battery Packs, UPS, Inverter, BSS, Solder Lighting
                      Solutions, Battery packs for different applications.
                    </p>
                  </div>
                </div>
                <span className="bgcall-block-number1">06</span>
                <div className="bg-overlay" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
{/*
  <div className="section-full1 mobile-page-padding p-tb301 bg-gray">
  <div className="container">
    <div className="section-content">
      <div className="logo-container">
        <div className="item">
          <a href="javascript:;" className="client-logo-pic1">
            <img src={clients1} alt="" />
            <div>
              <span>Allround</span>
            </div>
          </a>
        </div>
        <div className="item">
          <a href="javascript:;" className="client-logo-pic1">
            <img src={clients5} alt="" />
            <div>
              <span>SBI</span>
            </div>
          </a>
        </div>
        <div className="item">
          <a href="javascript:;" className="client-logo-pic1">
            <img src={clients6} alt="" />
            <div>
              <span>NABL</span>
            </div>
          </a>
        </div>
        <div className="item">
          <a href="javascript:;" className="client-logo-pic1">
            <img src={clients9} alt="" />
            <div>
              <span>PP</span>
            </div>
          </a>
        </div>
        <div className="item">
          <a href="javascript:;" className="client-logo-pic1">
            <img src={clients12} alt="" />
            <div>
              <span>SBI Life</span>
            </div>
          </a>
        </div>
        <div className="item">
          <a href="javascript:;" className="client-logo-pic1">
            <img src={clients14} alt="" />
            <div>
              <span>McDonald's</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

*/}
</div>


  );
}



export default Ourservices;
